import Box from 'shopper/components/Box';
import Spinner from 'shopper/components/Spinner';

const Loading = () => (
  <Box>
    <div className="flex h-[500px] flex-col items-center justify-center">
      <Spinner />
    </div>
  </Box>
);

export default Loading;
